import { COLOR_SYSTEM } from "components/design/design-system";
import { typography } from "components/design/typography";
import styled from "styled-components";

interface InputStyledProps {
  error?: boolean;
}

export const InputField = styled.input<InputStyledProps>`
  display: block;
  min-width: 30px;
  height: 100%;
  appearance: none;
  outline: none;
  border: none;
  flex: 1;
  margin-left: 8px;
  background-color: ${COLOR_SYSTEM.get("Gray")?.[0]};
  ${typography.get("Body2Medium")};

  &::placeholder {
    color: ${COLOR_SYSTEM.get("Gray")?.[300]};
  }

  &:focus {
    background-color: ${COLOR_SYSTEM.get("Gray")?.[0]};
  }
`;

export const InputWrapper = styled.div<InputStyledProps>`
  height: 48px;
  padding: 11.5px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ error }) =>
    COLOR_SYSTEM.get(error ? "Red" : "Gray")?.[0]};
  box-sizing: border-box;
  border-radius: 12px;
  border: 1px solid ${COLOR_SYSTEM.get("Gray")?.[50]};

  .left-items {
    margin-right: 10px;
  }

  .right-items {
  }

  .unit {
    margin-left: 5px;
  }
`;

export const Wrapper = styled.div`
  min-width: 120px;
  position: relative;
`;
